import React, { useState } from 'react';

/**
 * Podglad faktury XML przed zapisem.
 *
 * Propsy coverage / onWrocDoKroku1 / moznaOdblokowac / slotPodTabela sa OPCJONALNE
 * i uzywa ich Kreator dodawania faktury. Bez nich komponent zachowuje sie dokladnie
 * tak jak dotad (strona faktur zakupowych).
 *
 * Sekcja "Kontrahent" buduje sie z pola kontrahent_podglad, ktore endpoint
 * preview-xml dokleja do invoice_data. Gdy backend go nie zwroci (starsza wersja),
 * sekcja po prostu sie nie pojawia i nic nie blokuje.
 */
const FakturaXmlModal = ({
  fakturaPreview, isSavingFaktura, onSave, onClose,
  coverage = null, onWrocDoKroku1 = null, moznaOdblokowac = false, slotPodTabela = null,
  blad = null, onPrzejdzDoKreatora = null,
  // Opcjonalne: strona nadrzedna zapisuje wybranego kandydata w stanie podgladu.
  // Bez tego propsa wybor zapisujemy bezposrednio w obiekcie podgladu, zeby
  // dolecial do save-xml jako invoice.customer_id.
  onWybierzKontrahenta = null
}) => {
  // Hooki musza byc wolane przed jakimkolwiek wczesnym return - stad stan tutaj.
  const [wybranyKandydatId, setWybranyKandydatId] = useState(null);

  if (!fakturaPreview) return null;

  // Pokrycie moze przyjsc z podgladu (preview-xml) albo byc podane jawnie przez kreator
  const pokrycie = coverage || fakturaPreview.cennik_coverage || null;
  const zwolniony = pokrycie?.zwolniony === true;
  const brakPokrycia = !!pokrycie && pokrycie.ok === false && !zwolniony;
  const brakujace = Array.isArray(pokrycie?.brakujace) ? pokrycie.brakujace : [];
  // Faktura bez pozycji nie jest faktura - backend i tak odrzuci zapis
  const pustaFaktura = !Array.isArray(fakturaPreview.items) || fakturaPreview.items.length === 0;
  // ===== Kontrahent: decyzja pokazana ZANIM zapadnie =====
  const kontrahent = fakturaPreview.kontrahent_podglad || null;
  const statusKontrahenta = kontrahent?.status || null;
  const kandydaci = Array.isArray(kontrahent?.kandydaci) ? kontrahent.kandydaci : [];
  const wybranyKontrahentId =
    wybranyKandydatId || kontrahent?.wybrany_id || fakturaPreview.invoice?.customer_id || null;
  // Konflikt bez rozstrzygniecia = zapis zapisalby fakture na losowa karte.
  const konfliktNierozstrzygniety = statusKontrahenta === 'konflikt' && !wybranyKontrahentId;

  const wybierzKandydata = (kandydat) => {
    if (!kandydat?.id) return;
    setWybranyKandydatId(kandydat.id);
    if (onWybierzKontrahenta) {
      onWybierzKontrahenta(kandydat.id, kandydat);
      return;
    }
    // Fallback bez propsa: zapis wysyla caly obiekt invoice, wiec wybor
    // dopisany tutaj doleci do backendu jako customer_id.
    if (fakturaPreview.invoice) fakturaPreview.invoice.customer_id = kandydat.id;
  };

  const nazwaKandydata = (k) =>
    k?.nazwa_firmy || k?.nazwa || `${k?.imie || ''} ${k?.nazwisko || ''}`.trim() || 'Bez nazwy';

  const opisDopasowania = () => {
    const metoda = kontrahent?.dopasowanie || kontrahent?.sposob_dopasowania || kontrahent?.metoda || '';
    if (metoda === 'nip' || metoda === 'nip_norm') return 'dopasowano po NIP';
    if (metoda === 'alias' || metoda === 'nazwa') return 'dopasowano po nazwie z wcześniejszej korekty';
    if (metoda === 'reczne' || metoda === 'wybor') return 'wskazany ręcznie';
    return metoda || '';
  };

  // Kasjer nie moze zapisac faktury bez pokrycia; uprawniony ma osobna sciezke w slocie
  // Duplikat numeru (podglad z backendu: istniejaca) - zapis i tak dostalby 409, wiec przycisk od razu wylaczony.
  const duplikatNumeru = Boolean(fakturaPreview?.istniejaca);
  const zablokowanyZapis =
    pustaFaktura || (brakPokrycia && !moznaOdblokowac) || konfliktNierozstrzygniety || duplikatNumeru;

  const thStyle = { padding: '0.4rem', textAlign: 'left', borderBottom: '1px solid var(--border)' };

  // Przycisk wylaczony: #fff na var(--border) dawalo w motywie jasnym kontrast
  // 1.23:1 (i jeszcze mniej po globalnym opacity 0.5) - napis znikal calkowicie.
  const styleZapisu = (wylaczony) => ({
    padding: '6px 12px', fontSize: '12px', fontWeight: '600',
    backgroundColor: wylaczony ? 'var(--bg)' : 'var(--success)',
    color: wylaczony ? 'var(--text)' : '#fff',
    border: `1px solid ${wylaczony ? 'var(--border)' : 'var(--success)'}`,
    cursor: wylaczony ? 'not-allowed' : 'pointer'
  });

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '8px', width: '95%', maxWidth: '1000px',
        maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{
          padding: '1rem', borderBottom: '1px solid var(--border)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          background: 'linear-gradient(135deg, var(--info), var(--info))'
        }}>
          <div>
            <h5 style={{ margin: 0, color: '#fff' , fontSize: '14px' }}>
              {'📋'} Podgl{'ą'}d faktury XML
            </h5>
            <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '11px', marginTop: '0.25rem' }}>
              {fakturaPreview.filename}
            </div>
          </div>
          <button onClick={onClose}
            style={{ background: 'none',  color: '#fff' , fontSize: '20px', cursor: 'pointer' }}>{'×'}</button>
        </div>

        {/* Content */}
        <div style={{ flex: 1, minHeight: 0, overflow: 'auto', padding: '1rem' }}>
          {/* Blad zapisu MUSI byc widoczny WEWNATRZ modala: to overlay
              position:fixed, wiec paski statusu strony sa pod przyciemnieniem
              i uzytkownik widzial "nic sie nie stalo". */}
          {blad && (
            <div style={{
              backgroundColor: 'var(--danger-light)', border: '1px solid var(--danger)',
              color: 'var(--danger)', borderRadius: '4px', padding: '0.5rem 0.75rem',
              marginBottom: '1rem', fontSize: '12px', fontWeight: '600'
            }}>
              {'⛔'} {blad}
            </div>
          )}

          {pustaFaktura && (
            <div style={{
              backgroundColor: 'var(--danger-light)', border: '1px solid var(--danger)',
              color: 'var(--danger)', borderRadius: '4px', padding: '0.5rem 0.75rem',
              marginBottom: '1rem', fontSize: '12px', fontWeight: '600'
            }}>
              {'⛔'} Ten plik nie zawiera {'ż'}adnej pozycji faktury {'—'} nie ma czego zaksi{'ę'}gowa{'ć'}.
              Sprawd{'ź'}, czy to na pewno faktura, a nie cennik.
            </div>
          )}

          {/* Numer juz w systemie: zapis i tak zostanie odrzucony (409 FAKTURA_ISTNIEJE,
              wspolna bramka - numer unikalny we wszystkich sklepach). Pokazujemy, GDZIE jest. */}
          {fakturaPreview.already_exists && (
            <div data-testid="podglad-duplikat" style={{ backgroundColor: 'var(--danger-light)', border: '1px solid var(--danger)', color: 'var(--danger)', borderRadius: '4px', padding: '0.75rem', marginBottom: '1rem', fontSize: '12px' }}>
              {'⛔'} <strong>Faktura {fakturaPreview.invoice?.numer_faktury} jest ju{'ż'} w systemie</strong>
              {fakturaPreview.istniejaca && (
                <>
                  {' '}({fakturaPreview.istniejaca.sklep || 'bez sklepu'}, id {fakturaPreview.istniejaca.id}
                  {fakturaPreview.istniejaca.dodano ? `, dodana ${fakturaPreview.istniejaca.dodano}` : ''}
                  {fakturaPreview.istniejaca.kto ? ` przez ${fakturaPreview.istniejaca.kto}` : ''})
                </>
              )}
              . Nie zostanie dodana drugi raz.
              {fakturaPreview.istniejaca?.id && (
                <>
                  {' '}
                  <a href={`/purchase-invoices/${fakturaPreview.istniejaca.id}`} style={{ color: 'var(--danger)', fontWeight: 600 }}>
                    Otw{'ó'}rz istniej{'ą'}c{'ą'} faktur{'ę'}
                  </a>
                </>
              )}
            </div>
          )}

          {/* Pasek pokrycia cennikiem */}
          {pokrycie && zwolniony && (
            <div style={{ backgroundColor: 'var(--info-light)', border: '1px solid var(--info)', borderRadius: '4px', padding: '0.5rem 0.75rem', marginBottom: '1rem', fontSize: '12px', color: 'var(--info)' }}>
              {'🧾'} Paragon {'—'} cennik nie jest wymagany.
            </div>
          )}
          {pokrycie && !zwolniony && pokrycie.ok === true && (
            <div style={{ backgroundColor: 'var(--success-light)', border: '1px solid var(--success)', borderRadius: '4px', padding: '0.5rem 0.75rem', marginBottom: '1rem', fontSize: '12px', color: 'var(--success)' }}>
              {'✅'} Wszystkie pozycje ({pokrycie.pokryte != null ? pokrycie.pokryte : (fakturaPreview.stats?.total_items || 0)}) maj{'ą'} pokrycie w systemie.
            </div>
          )}
          {brakPokrycia && (
            <div style={{ backgroundColor: 'var(--danger-light)', border: '1px solid var(--danger)', borderRadius: '4px', padding: '0.5rem 0.75rem', marginBottom: '1rem', fontSize: '12px', color: 'var(--danger)', fontWeight: '600' }}>
              {'⛔'} Brak pokrycia dla {brakujace.length || pokrycie.brak || 0} z {pokrycie.total != null ? pokrycie.total : (fakturaPreview.stats?.total_items || 0)} pozycji.
            </div>
          )}

          {/* Kontrahent - decyzja systemu PRZED zapisem. Blok stoi nad lista
              pozycji, zeby byl widoczny bez przewijania. */}
          {kontrahent && (
            <div style={{
              marginBottom: '1rem', borderRadius: '4px', overflow: 'hidden',
              border: `1px solid ${
                statusKontrahenta === 'znaleziony' ? 'var(--success)'
                  : statusKontrahenta === 'nowa_karta' ? 'var(--info)'
                  : statusKontrahenta === 'do_sparowania' ? 'var(--warning)'
                  : statusKontrahenta === 'konflikt' ? 'var(--danger)'
                  : 'var(--border)'
              }`
            }}>
              <div style={{
                padding: '0.5rem 0.75rem', fontSize: '12px', fontWeight: '600',
                backgroundColor:
                  statusKontrahenta === 'znaleziony' ? 'var(--success-light)'
                    : statusKontrahenta === 'nowa_karta' ? 'var(--info-light)'
                    : statusKontrahenta === 'do_sparowania' ? 'var(--warning-light)'
                    : statusKontrahenta === 'konflikt' ? 'var(--danger-light)'
                    : 'var(--bg)',
                color:
                  statusKontrahenta === 'znaleziony' ? 'var(--success)'
                    : statusKontrahenta === 'nowa_karta' ? 'var(--info)'
                    : statusKontrahenta === 'do_sparowania' ? 'var(--warning)'
                    : statusKontrahenta === 'konflikt' ? 'var(--danger)'
                    : 'var(--text-muted)'
              }}>
                {statusKontrahenta === 'znaleziony' && (
                  <>
                    {'✅'} Kontrahent znaleziony w kartotece: {kontrahent.nazwa_w_kartotece || nazwaKandydata(kontrahent)}
                    {opisDopasowania() ? ` (${opisDopasowania()})` : ''}
                  </>
                )}
                {statusKontrahenta === 'nowa_karta' && (
                  <>
                    {'🆕'} Zostanie za{'ł'}o{'ż'}ona nowa karta kontrahenta (NIP {kontrahent.nip || fakturaPreview.invoice?.dostawca_nip || '-'})
                  </>
                )}
                {statusKontrahenta === 'do_sparowania' && (
                  <>
                    {'⚠️'} Brak NIP-u i brak dopasowania {'—'} faktura zapisze si{'ę'} bez kontrahenta
                    i trafi do listy do sparowania
                  </>
                )}
                {statusKontrahenta === 'konflikt' && (
                  <>
                    {'⛔'} Znaleziono kilka kart z tym NIP-em {'—'} wybierz w{'ł'}a{'ś'}ciw{'ą'}
                  </>
                )}
                {statusKontrahenta === 'pominiety' && (
                  <>
                    {'ℹ️'} Dokument techniczny {'—'} kontrahent nie b{'ę'}dzie przypisywany
                  </>
                )}
                {!['znaleziony', 'nowa_karta', 'do_sparowania', 'konflikt', 'pominiety'].includes(statusKontrahenta || '') && (
                  <>Kontrahent: {kontrahent.komunikat || 'brak informacji'}</>
                )}
              </div>

              {kontrahent.komunikat && statusKontrahenta !== 'konflikt' && (
                <div style={{ padding: '0.4rem 0.75rem', fontSize: '10px', color: 'var(--text-muted)', backgroundColor: 'var(--card-bg)' }}>
                  {kontrahent.komunikat}
                </div>
              )}

              {statusKontrahenta === 'konflikt' && kandydaci.length > 0 && (
                <div style={{ backgroundColor: 'var(--card-bg)', maxHeight: '180px', overflowY: 'auto' }}>
                  {kandydaci.map((k) => {
                    const aktywny = wybranyKontrahentId === k.id;
                    return (
                      <div key={k.id} style={{
                        display: 'flex', alignItems: 'center', gap: '8px',
                        padding: '0.4rem 0.75rem', borderTop: '1px solid var(--border)'
                      }}>
                        <div style={{ flex: 1, minWidth: 0, fontSize: '12px' }}>
                          <div style={{ fontWeight: '600' }}>{nazwaKandydata(k)}</div>
                          <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
                            {k.numer_klienta ? `nr ${k.numer_klienta} | ` : ''}
                            {k.nip ? `NIP: ${k.nip}` : 'bez NIP'}
                            {k.miasto ? ` | ${k.miasto}` : ''}
                            {k.liczba_faktur != null ? ` | faktur: ${k.liczba_faktur}` : ''}
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => wybierzKandydata(k)}
                          style={{
                            padding: '4px 10px', fontSize: '11px', cursor: 'pointer', borderRadius: '4px',
                            border: '1px solid var(--primary)',
                            backgroundColor: aktywny ? 'var(--primary)' : 'var(--card-bg)',
                            color: aktywny ? '#fff' : 'var(--primary)',
                            fontWeight: aktywny ? '600' : '400'
                          }}
                        >
                          {aktywny ? 'Wybrana' : 'Wybierz'}
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* Invoice data */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
            <div style={{ backgroundColor: 'var(--bg)', padding: '0.75rem', borderRadius: '4px' }}>
              <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginBottom: '0.25rem' }}>Numer faktury</div>
              <div style={{ fontWeight: '600', fontSize: '14px' }}>{fakturaPreview.invoice?.numer_faktury || '-'}</div>
            </div>
            <div style={{ backgroundColor: 'var(--bg)', padding: '0.75rem', borderRadius: '4px' }}>
              <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginBottom: '0.25rem' }}>Data wystawienia</div>
              <div style={{ fontWeight: '600', fontSize: '14px' }}>{fakturaPreview.invoice?.data_wystawienia || '-'}</div>
            </div>
            <div style={{ backgroundColor: 'var(--bg)', padding: '0.75rem', borderRadius: '4px' }}>
              <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginBottom: '0.25rem' }}>Dostawca</div>
              <div style={{ fontWeight: '600', fontSize: '14px' }}>{fakturaPreview.invoice?.dostawca_nazwa || '-'}</div>
              <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>NIP: {fakturaPreview.invoice?.dostawca_nip || '-'}</div>
            </div>
            <div style={{ backgroundColor: 'var(--bg)', padding: '0.75rem', borderRadius: '4px' }}>
              <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginBottom: '0.25rem' }}>Kwota brutto</div>
              <div style={{ fontWeight: '700', fontSize: '16px', color: 'var(--success)' }}>
                {parseFloat(fakturaPreview.invoice?.suma_brutto || 0).toFixed(2)} z{'ł'}
              </div>
            </div>
          </div>

          {/* Stats */}
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
            <div style={{ backgroundColor: 'var(--info-light)', padding: '0.5rem 1rem', borderRadius: '4px', fontSize: '12px' }}>
              {'📦'} Pozycji: <strong>{fakturaPreview.stats?.total_items || 0}</strong>
            </div>
            <div style={{ backgroundColor: 'var(--success-light)', padding: '0.5rem 1rem', borderRadius: '4px', fontSize: '12px' }}>
              {'✅'} Zmapowanych: <strong>{fakturaPreview.stats?.mapped || 0}</strong>
            </div>
            <div style={{ backgroundColor: 'var(--orange-light)', padding: '0.5rem 1rem', borderRadius: '4px', fontSize: '12px' }}>
              {'❓'} Nieznanych: <strong>{fakturaPreview.stats?.unmapped || 0}</strong>
            </div>
          </div>

          {/* Items list */}
          <div style={{ border: '1px solid var(--border)', borderRadius: '4px', overflow: 'hidden' }}>
            <div style={{ backgroundColor: 'var(--bg)', padding: '0.5rem', fontWeight: '600', fontSize: '12px', borderBottom: '1px solid var(--border)' }}>
              Pozycje faktury
            </div>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
                <thead>
                  <tr style={{ backgroundColor: 'var(--bg)' }}>
                    <th style={thStyle}>Nazwa</th>
                    <th style={thStyle}>Kod/EAN</th>
                    <th style={{ ...thStyle, textAlign: 'right' }}>Ilo{'ść'}</th>
                    <th style={{ ...thStyle, textAlign: 'right', color: 'var(--text-muted)' }} title="Stara cena zakupu netto z systemu">Stara cena zak.</th>
                    <th style={{ ...thStyle, textAlign: 'right' }} title="Nowa cena netto z faktury">Nowa cena netto</th>
                    <th style={{ ...thStyle, textAlign: 'right' }} title="Wartosc netto z faktury">Warto{'ść'} netto</th>
                    <th style={{ ...thStyle, textAlign: 'center' }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {fakturaPreview.items?.map((item, idx) => {
                    const ilosc = parseFloat(item.ilosc) || 1;
                    const newCenaNetto = parseFloat(item.cena_netto || 0)
                      || (parseFloat(item.wartosc_netto || 0) / ilosc) || 0;
                    const oldCenaNetto = item.old_purchase_netto != null ? parseFloat(item.old_purchase_netto) : null;
                    const wartoscNetto = parseFloat(item.wartosc_netto || 0)
                      || (parseFloat(item.wartosc_brutto || 0) / 1.23);
                    // Parsery ustawiaja pole nazwa_produktu; item.nazwa zostaje jako fallback
                    // dla parserow, ktore moglyby uzywac starej nazwy pola.
                    const nazwaPozycji = item.nazwa_produktu || item.nazwa || '';
                    const nazwaWSystemie = item.product_name_in_system || '';
                    const nazwaSieRozni = !!nazwaPozycji && !!nazwaWSystemie && nazwaWSystemie !== nazwaPozycji;
                    // Kolor "nowa cena": zielony jesli niższa, czerwony jesli wyższa od starej
                    let cenaColor = 'inherit';
                    if (oldCenaNetto != null && oldCenaNetto > 0 && newCenaNetto > 0) {
                      cenaColor = newCenaNetto > oldCenaNetto ? 'var(--danger)'
                        : newCenaNetto < oldCenaNetto ? 'var(--success)'
                        : 'inherit';
                    }
                    return (
                    <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)' }}>
                      <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)' }}>
                        {nazwaPozycji || '-'}
                        {item.mapped && nazwaSieRozni && (
                          <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{'→'} {nazwaWSystemie}</div>
                        )}
                        {item.brak_vat_w_dokumencie && (
                          <div style={{ fontSize: '10px', color: 'var(--danger)', fontWeight: '600' }}>
                            {'⚠️'} brak stawki VAT w pliku
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', color: 'var(--text-muted)' }}>
                        {item.kod_produktu || item.ean || '-'}
                      </td>
                      <td style={{ padding: '0.4rem', textAlign: 'right', borderBottom: '1px solid var(--border)' }}>{ilosc}</td>
                      <td style={{ padding: '0.4rem', textAlign: 'right', borderBottom: '1px solid var(--border)', color: 'var(--text-muted)' }}>
                        {oldCenaNetto != null ? oldCenaNetto.toFixed(2) : '-'}
                      </td>
                      <td style={{ padding: '0.4rem', textAlign: 'right', borderBottom: '1px solid var(--border)', color: cenaColor, fontWeight: cenaColor !== 'inherit' ? '600' : '400' }}>
                        {newCenaNetto.toFixed(2)}
                      </td>
                      <td style={{ padding: '0.4rem', textAlign: 'right', borderBottom: '1px solid var(--border)', fontWeight: '500' }}>{wartoscNetto.toFixed(2)}</td>
                      <td style={{ padding: '0.4rem', textAlign: 'center', borderBottom: '1px solid var(--border)' }}>
                        {item.mapped ? (
                          <span style={{ color: 'var(--success)', fontSize: '10px' }}>{'✅'} Zmapowany</span>
                        ) : (
                          <span style={{
                            display: 'inline-block', padding: '1px 6px', borderRadius: '3px',
                            backgroundColor: 'var(--warning)', color: '#fff', fontSize: '10px', fontWeight: '600'
                          }}>NOWY</span>
                        )}
                      </td>
                    </tr>
                  );})}
                </tbody>
              </table>
            </div>
          </div>

          {/* Lista pozycji bez pokrycia w cenniku.
              Gdy kreator poda wlasny slot (CoverageWarning), nie dublujemy tabelki. */}
          {brakPokrycia && !slotPodTabela && (
            <div style={{
              marginTop: '1rem', border: '1px solid var(--danger)', borderRadius: '4px',
              backgroundColor: 'var(--danger-light)', overflow: 'hidden'
            }}>
              <div style={{ padding: '0.5rem 0.75rem', fontSize: '12px', fontWeight: '600', color: 'var(--danger)' }}>
                Zmapowane: {pokrycie.pokryte != null ? pokrycie.pokryte : Math.max(0, (pokrycie.total || 0) - brakujace.length)} / {pokrycie.total != null ? pokrycie.total : (fakturaPreview.stats?.total_items || 0)}.
                {' '}{brakujace.length || pokrycie.brak || 0} pozycji nie ma odpowiednika w systemie.
              </div>
              {brakujace.length > 0 && (
                <div style={{ maxHeight: '180px', overflowY: 'auto', backgroundColor: 'var(--card-bg)' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                    <thead>
                      <tr style={{ backgroundColor: 'var(--bg)' }}>
                        <th style={thStyle}>Kod</th>
                        <th style={thStyle}>EAN</th>
                        <th style={thStyle}>Nazwa z XML</th>
                        <th style={{ ...thStyle, textAlign: 'right' }}>Ilo{'ść'}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {brakujace.map((b, i) => (
                        <tr key={i}>
                          <td style={{ padding: '0.3rem 0.4rem', borderBottom: '1px solid var(--border)', fontFamily: 'monospace' }}>{b.kod_produktu || b.kod || '-'}</td>
                          <td style={{ padding: '0.3rem 0.4rem', borderBottom: '1px solid var(--border)', fontFamily: 'monospace' }}>{b.ean || '-'}</td>
                          <td style={{ padding: '0.3rem 0.4rem', borderBottom: '1px solid var(--border)' }}>{b.nazwa_produktu || b.nazwa || '-'}</td>
                          <td style={{ padding: '0.3rem 0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>{b.ilosc != null ? b.ilosc : '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {/* ZAWSZE co najmniej jedno wyjscie dalej. Na zwyklej stronie faktur
                  zakupowych nie ma kroku 1, wiec prowadzimy do Kreatora - inaczej
                  jedynym wyjsciem bylo "Anuluj" (slepa uliczka). */}
              <div style={{ padding: '0.5rem 0.75rem', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {onWrocDoKroku1 && (
                  <button onClick={onWrocDoKroku1}
                    style={{
                      padding: '4px 10px', fontSize: '11px', border: '1px solid var(--primary)',
                      backgroundColor: 'var(--primary)', color: '#fff', cursor: 'pointer', borderRadius: '4px'
                    }}>
                    Wr{'ó'}{'ć'} do Kroku 1 i wgraj cennik
                  </button>
                )}
                {!onWrocDoKroku1 && onPrzejdzDoKreatora && (
                  <button onClick={onPrzejdzDoKreatora}
                    style={{
                      padding: '4px 10px', fontSize: '11px', border: '1px solid var(--primary)',
                      backgroundColor: 'var(--primary)', color: '#fff', cursor: 'pointer', borderRadius: '4px'
                    }}>
                    Otw{'ó'}rz Kreator i wgraj cennik
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Slot kreatora (np. panel administratora) */}
          {slotPodTabela}
        </div>

        {/* Footer */}
        <div style={{ padding: '1rem', borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
            Suma: {parseFloat(fakturaPreview.invoice?.suma_brutto || 0).toFixed(2)} z{'ł'}
          </div>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            {zablokowanyZapis && (
              <div style={{ fontSize: '10px', color: 'var(--text-muted)', maxWidth: '260px', textAlign: 'right' }}>
                {pustaFaktura
                  ? 'Plik nie zawiera pozycji faktury'
                  : konfliktNierozstrzygniety
                    ? 'Wybierz właściwą kartę kontrahenta powyżej'
                    : 'Najpierw wgraj cennik dla brakujących pozycji'}
              </div>
            )}
            <button onClick={onClose}
              style={{ padding: '6px 12px', fontSize: '12px', border: '1px solid var(--border)', backgroundColor: 'var(--card-bg)', color: 'var(--text-secondary)', cursor: 'pointer' }}>
              Anuluj
            </button>
            <button onClick={onSave}
              disabled={isSavingFaktura || zablokowanyZapis}
              style={styleZapisu(isSavingFaktura || zablokowanyZapis)}>
              {isSavingFaktura ? '⏳ Zapisywanie...' : duplikatNumeru ? '⛔ Już w systemie' : '✅ Importuj fakturę'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FakturaXmlModal;
